export default __webpack_public_path__ + "static/7-levels-of-stack-f83d4822d6226f80657a5041cab96177.png";